import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { COUNTRY } from 'common/constants';
import { getInsuranceList, getInsuranceListForCanada, requestClinic, updateBookingWidgetSlot } from 'connect/actions';

import { selectInsuranceListForCountry } from 'connect/selectors';
import { CurrentStep } from 'pages/checkout-v3/components/StepManager/CurrentStep';
import { selectDataClinic } from 'pages/profile/connect/selectors';

import { EXPERIMENTS } from 'utils/constants/experiment-configs';

import { useExperiment } from 'utils/customHooks/useExperiment';

import { CheckoutGlobalStyle, CheckoutPageWrapper, CheckoutStepWrapper, TopSection } from './CheckoutPage-styled-components';
import { Navbar } from './components/Navbar/Navbar';
import { OfferBanner } from './components/OfferBanner/OfferBanner';
import { Progress } from './components/Progress/Progress';
import { resetCheckoutData } from './connect/helpers';

export const CheckoutPage = () => {
  const dispatch = useDispatch();
  const { params } = useRouteMatch();
  const { clinicId: clinicIdString } = params as { clinicId: string; };
  const clinicId = parseInt(clinicIdString, 10);

  // We don't need the value from useExperiment, just the tracking
  useExperiment({ experiment: EXPERIMENTS.CHECKOUT_REDESIGN_AUTH_FLOW });
  useExperiment({ experiment: EXPERIMENTS.CHECKOUT_REDESIGN_FULLTIME });

  // Reset all saga loading and error states on first load
  // This makes sure we don't have any stale data from previous visits
  useEffect(() => {
    resetCheckoutData(dispatch);

    // Reset booking widget slot to acknowledge its been handled
    dispatch(updateBookingWidgetSlot(null, null, null));
  }, [dispatch]);

  const clinicData = useSelector(selectDataClinic);
  useEffect(() => {
    if (clinicData?.id === clinicId) {
      return;
    }

    // Either clinicData is not loaded or clinicId has changed
    dispatch(requestClinic(clinicId));
  }, [clinicId, clinicData, dispatch]);

  const insuranceList = useSelector(selectInsuranceListForCountry);
  useEffect(() => {
    if (insuranceList?.length) {
      return;
    }

    if (clinicData?.address?.country === COUNTRY.canada) {
      dispatch(getInsuranceListForCanada());
      return;
    }

    dispatch(getInsuranceList());
  }, [insuranceList, dispatch, clinicData?.address?.country]);

  return (
    <>
      <CheckoutGlobalStyle />

      <CheckoutPageWrapper>
        <TopSection>
          <Navbar />
          <Progress />
        </TopSection>

        <CheckoutStepWrapper>
          <OfferBanner />
          <CurrentStep />
        </CheckoutStepWrapper>
      </CheckoutPageWrapper>
    </>
  );
};
